import { render, staticRenderFns } from "./adminDashboardView.vue?vue&type=template&id=20ed71ba&scoped=true"
import script from "./adminDashboardView.vue?vue&type=script&lang=js"
export * from "./adminDashboardView.vue?vue&type=script&lang=js"
import style0 from "./adminDashboardView.vue?vue&type=style&index=0&id=20ed71ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed71ba",
  null
  
)

export default component.exports